import React, { useState, useEffect } from 'react';
import ReactDOMServer from "react-dom/server";
import jsPDF from "jspdf";
import {
  getLogistica,
  getLiquidacionPorIdOrdenes,
  getLiquidacionPorIdNovedades
} from '../../../../api/axios.js';

export default function LiquidacionToPDF({ request, liquidacion_por_id, updateHiddenSpinner }) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    updateHiddenSpinner(isLoading)
  }, [isLoading]);

  const exportarPdf = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    await getLiquidacionPorIdOrdenes(request).then(res => {
      var objeto = res['ordenes'];
      var html_ordenes = "";
      for (var j in objeto) {
        html_ordenes =
          html_ordenes
          + "<tr><td style={{ width: '720px', fontSize: '13px' }}>"
          + objeto[j]['fechaOrdenMostrar'] + "</td ><td>"
          + objeto[j]['idOrden'] + "</td><td >"
          + objeto[j]['tipoPublicacion'] + "</td><td>$"
          + objeto[j]['importeOrden'] + "</td><td>$"
          + objeto[j]['importeComisionNeta'] + "</td><td>$"
          + objeto[j]['importeComisionTotal'] + "</td><td>$"
          + objeto[j]['totalOrden'] + "</td></tr >";
      }
      localStorage.setItem("imprime_html_ordenes", html_ordenes);
    });

    await getLiquidacionPorIdNovedades(request).then(res => {
      var objeto = res['novedadesDeLiquidacion'];
      var html_novedades = "";
      for (var j in objeto) {
        if (objeto[j]['idLiquidacion'] != 0) {
          html_novedades =
            html_novedades
            + "<tr><td style={{ width: '720px', fontSize: '13px' }}>"
            + objeto[j]['fechaNovedadMostrar'] + "</td><td>"
            + objeto[j]['tipoNovedadDescripcion'] + "</td><td>$"
            + objeto[j]['importeNovedad'] + "</td></tr>";
        }
      }
      localStorage.setItem("imprime_html_novedades", html_novedades);
    });

    request.idLiquidacion = [request.idLiquidacion];
    await getLogistica(request).then(res => {
      var objeto = res['datosFee'];
      var html_logistica = "";
      for (var j in objeto) {
        html_logistica =
          html_logistica
          + "<tr><td style={{ width: '720px', fontSize: '13px' }}>"
          + objeto[j]['pesoHasta'] + "</td><td>"
          + objeto[j]['idCotizacion'] + "</td><td>"
          + objeto[j]['pesoAforado'] + "</td><td>$"
          + objeto[j]['importe'] + "</td></tr>";
      }
      localStorage.setItem("imprime_html_logistica", html_logistica);
    });

    let imprime_html_ordenes = localStorage.getItem("imprime_html_ordenes");
    let imprime_html_novedades = localStorage.getItem("imprime_html_novedades");
    let imprime_html_logistica = localStorage.getItem("imprime_html_logistica");

    let encabezado = liquidacion_por_id;
    const divider = <hr className="color-rojo-megatone" />;
    const styleMargin = { marginLeft: "30px", fontSize: "8px" };
    const styleWidth = (width) => { return { ...styleMargin, width: width } };

    let pdf =
      (<div style={{ width: '611px', fontFamily: 'Verdana' }}>

        <div className="row justify-content-evenly align-items-center my-3">
          <div className="col-3">
            <img src="/img/megatone.jpg" alt="megatone_logo" width="40" />
          </div>

          <div className="col-auto">
            <span style={{ fontSize: '13px' }}>Liquidación de Comisiones</span>
          </div>

          <div className="col-auto">
            <img src="/img/logo-marketplace-megatone.png" alt="megamarket_logo" width="120" />
          </div>
        </div>

        <div className="row" style={styleMargin}>
          <span><strong>Fecha:  {encabezado.mostrarFecha}</strong></span>
          <span><strong>Liquidación N°: {encabezado.idLiquidacion}</strong></span>
          <span><strong>Seller: {encabezado.razonSocialSeller}</strong></span>
          <span>Liquidacion desde: {encabezado.fechaDesde} hasta: {encabezado.fechaHasta}</span>
        </div>

        {divider}

        <div className="col-12" style={styleMargin}>
          <span><strong>Ordenes Liquidadas</strong></span>
        </div>

        <table style={styleWidth(520)}>
          <thead >
            <tr>
              <th style={{ width: '80px' }}>Fecha</th>
              <th style={{ width: '40px' }}>N°</th>
              <th style={{ width: '340px' }}>Tipo</th>
              <th style={{ width: '80px' }}>Importe</th>
              <th style={{ width: '80px' }}>Com. Neta</th>
              <th style={{ width: '80px' }}>Com. Total</th>
              <th style={{ width: '80px' }}>Total</th>
            </tr>
          </thead>
          <tbody style={{ width: '720px' }}>
            <div dangerouslySetInnerHTML={{ __html: imprime_html_ordenes }}></div>
          </tbody>
        </table>

        <br />

        <div style={styleWidth(720)}>
          <span style={{ width: '720px' }}>
            <strong>Total Ordenes: ${encabezado.totalOrden}</strong>
          </span>
          <br />
          <span style={{ width: '720px' }}>
            <strong>Comisión Neta: ${encabezado.comisionNeta}</strong>
          </span>
          <br />
          <span style={{ width: '720px' }}>
            <strong>Comisión Total: ${encabezado.comisionTotal}</strong>
          </span>
          <br />
        </div>

        {divider}

        <div style={styleMargin}>
          <span><strong>Novedades Liquidadas</strong></span>
        </div>

        <table style={styleWidth(520)}>
          <thead>
            <tr>
              <th style={{ width: '80px' }}>Fecha</th>
              <th style={{ width: '200px' }}>Concepto</th>
              <th style={{ width: '80px' }}>Importe</th>
            </tr>
          </thead>
          <tbody>
            <div dangerouslySetInnerHTML={{ __html: imprime_html_novedades }}></div>
          </tbody>
        </table>

        <br />

        <div style={styleWidth(720)}>
          <span style={{ width: '720px' }}>
            <strong>Total Novedades: ${encabezado.totalNovedades} </strong>
          </span>
          <br />
        </div>

        {divider}

        <div style={styleMargin}>
          <span><strong>Fee Logistico</strong></span>
        </div>

        <table style={styleWidth(520)}>
          <thead >
            <tr>
              <th style={{ width: '80px' }}>Peso Hasta</th>
              <th style={{ width: '80px' }}>Id Cotizacion</th>
              <th style={{ width: '100px' }}>Peso Aforado</th>
              <th style={{ width: '100px' }}>Importe</th>
            </tr>
          </thead>
          <tbody>
            <div dangerouslySetInnerHTML={{ __html: imprime_html_logistica }}></div>
          </tbody>
        </table>

        {divider}

        <div className="row justify-content-end align-items-center">
          <div className="col-5" style={{ fontSize: '10px' }}>
            <div className="row w-100 justify-content-center">
              <div className="col-6 text-end"><span>Total Ordenes:</span></div>
              <div className="col-6"><span>${encabezado.totalOrden}</span></div>
              <div className="col-6 text-end"><span>Total Comisiones:</span></div>
              <div className="col-6"><span>${encabezado.comisionTotal}</span></div>
              <div className="col-6 text-end"><span>Total Novedades:</span></div>
              <div className="col-6"><span>${encabezado.totalNovedades}</span></div>
              <div className="col-6 text-end"><span>Costo Fee Neto:</span></div>
              <div className="col-6"><span>${encabezado.totalCostoFeeNeto}</span></div>
              <div className="col-6 text-end"><span>Total Costo Fee:</span></div>
              <div className="col-6"><span>${encabezado.totalCostoFee}</span></div>
              <div className="col-6 text-end"><span><strong>Neto:</strong></span></div>
              <div className="col-6"><span>${encabezado.totalLiquidacion}</span></div>
            </div>
          </div>
        </div>

      </div>);

    const doc = new jsPDF("p", "pt", "letter");
    doc.html(ReactDOMServer.renderToString(pdf), {
      margin: [15, 0, 15, 0],
      callback: function (result) {
        result.save('Liquidacion:' + encabezado.razonSocialSeller + '.pdf');
      }
    });

    setIsLoading(false);
  };

  return (
    <button
      className="btn btn-sm background-rojo-megatone text-center"
      onClick={exportarPdf}
      disabled={isLoading}
    >
      Exportar a PDF
    </button>
  )
}